<template>
    <div>
        <h3 class="subtitle">{{$t("settings.personal.settings")}}</h3>
        <table class="table">
            <tbody>
            <tr>
                <td>
                {{$t("settings.personal.weekHours")}}
                </td>
                <td>
                <input class="input is-primary" type="number" v-model.number="personalSettings.workWeekTime" :disabled="!enableFields">
                </td>
            </tr>
            <tr>
                <td>
                    {{$t("settings.personal.workHours")}}<br>
                    <span class="tag is-light" v-if="weekSum > 0">{{weekSum}}</span>
                </td>
                <td>
                    <div class="columns">
                        <div class="column">
                            <small>{{$t("settings.personal.monday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.monday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.tuesday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.tuesday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.wednesday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.wednesday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.thursday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.thursday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.friday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.friday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.saturday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.saturday" :disabled="!enableFields">
                        </div>
                        <div class="column">
                            <small>{{$t("settings.personal.sunday")}}</small>
                            <input class="input is-primary" type="number" v-model.number="personalSettings.sunday" :disabled="!enableFields">
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <span class="button is-small is-danger is-outlined" v-if="weekSum > personalSettings.workWeekTime" disabled>{{$t("settings.personal.warning")}}</span>
                </td>
                <td>
                    <p class="buttons">
                        <a @click="enabledLockedFields()" v-if="!enableFields" class="button is-small is-info">
                            <span class="icon">
                                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                            </span>
                            {{$t("input.edit")}}
                        </a>
                        <a @click="updateSettings()" v-if="enableFields" class="button is-small is-primary">
                            <span class="icon">
                                <font-awesome-icon icon="check"></font-awesome-icon>
                            </span>
                            {{$t("input.save")}}
                        </a>
                        <a @click="enableFields = false" v-if="enableFields" class="button is-small is-danger">
                            <span class="icon">
                                <font-awesome-icon icon="times"></font-awesome-icon>
                            </span>
                             {{$t("input.cancel")}}
                        </a>
                    </p>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'SettingsPersonalTime',
  props: {
  },
  data: function() {
    return {
      enableFields: false,
      personalSettings: {},
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        personalSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/settings'),
            asObject: true
        },
    }
  },
  computed: {
    weekSum: function(){
      return Number(this.personalSettings.monday) +
              Number(this.personalSettings.tuesday) +
              Number(this.personalSettings.wednesday) +
              Number(this.personalSettings.thursday) +
              Number(this.personalSettings.friday) +
              Number(this.personalSettings.saturday) +
              Number(this.personalSettings.sunday);
    },
  },
  methods: {
    enabledLockedFields: function() {
      this.enableFields = true;
    },
    updateSettings: function() {
      if (this.enableFields == true) {
        var now = moment().format();
        var wwtime = this.personalSettings.workWeekTime || 0;
        var mon = this.personalSettings.monday || 0;
        var tues = this.personalSettings.tuesday || 0;
        var wed = this.personalSettings.wednesday || 0;
        var thur = this.personalSettings.thursday || 0;
        var fri = this.personalSettings.friday || 0;
        var sat = this.personalSettings.saturday || 0;
        var sun = this.personalSettings.sunday || 0;

        var updates = {
          'workWeekTime': wwtime,
          'timestampLastEdited': now,
          'monday': mon,
          'tuesday': tues,
          'wednesday': wed,
          'thursday': thur,
          'friday': fri,
          'saturday': sat,
          'sunday': sun,
        };
        this.$firebaseRefs.personalSettings.update(updates);
        this.enableFields = false;
      } else {

      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .icon {
        margin-right: 0.375em!important;
    }
</style>
